import clsx from 'clsx';
import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import { FormProvider } from 'react-hook-form';

import { NewPlpTypes } from 'lib/apis/services/NewPlpListiing';
import { useFilterBoxWrapper } from '../../hooks/useFilterBoxWrapper';
interface Props extends PropsWithChildren {
  submitHandler: (_data: NewPlpTypes.DecodeUrlResultType) => void;
}

function FilterBoxWrapper({ children, submitHandler }: Props) {
  const { scrollPositionChanged, methods } = useFilterBoxWrapper();
  return (
    <div
      className={clsx(
        'sticky top-0 bg-white min-h-[8rem] max-h-max flex md:border-b z-10',
        {
          'z-10': !scrollPositionChanged,
          'z-[101] border-b': scrollPositionChanged,
        }
      )}
    >
      <div className="container mx-auto">
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(submitHandler)}
            className="flex flex-col py-4 space-y-4"
          >
            {children}
          </form>
        </FormProvider>
      </div>
    </div>
  );
}

export default observer(FilterBoxWrapper);
